<div
  *ngIf="creditCard"
  class="credit-card clickable"
  fxLayout="column"
  fxLayoutAlign="space-between"
  (click)="onCardClick()"
>
  <div class="credit-card__logo">
    <img
      src="assets/images/settings/payment-methods/{{ creditCard.cardType }}.svg"
      alt=""
    />
  </div>
  <div class="credit-card__bookmark" *ngIf="creditCard.default">
    <mat-icon color="primary">bookmark</mat-icon>
  </div>
  <div fxLayout fxLayoutAlign="space-between">
    <div>
      <p class="mb-5">
        {{ 'paymentMethods.cardNumber' | translate | uppercase }}
      </p>
      <p class="text-yellow">{{ creditCard.cardNumber }}</p>
    </div>
    <div *ngIf="deleteMode" (click)="$event.stopPropagation()">
      <mat-checkbox color="primary"></mat-checkbox>
    </div>
  </div>
  <div fxLayout fxLayoutAlign="space-between center">
    <div>
      <p class="mb-5">
        {{ 'paymentMethods.cardHolderName' | translate | uppercase }}
      </p>
      <p class="text-white">{{ creditCard.cardHolderName }}</p>
    </div>
    <div fxLayout="column" fxLayoutAlign="end end">
      <p class="mb-5">
        {{ 'paymentMethods.valid' | translate | uppercase }}
      </p>
      <p class="text-white">{{ creditCard.valid }}</p>
    </div>
  </div>
</div>
